<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        outlined
      >
        {{ locale.toUpperCase() }}
        <v-icon>{{ mdiMenuDown }}</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="item in locales"
        :key="item.locale"
        @click="switchLocale(item.locale)"
      >
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiMenuDown } from '@mdi/js';

export default {
  name: 'LocaleSwitcher',
  props: {
    /** Set the locale. Defaults to en.
    */
    value: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      mdiMenuDown,
      supportedLocales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
      locale: this.$i18n.locale ?? this.value,
      localeList: [
        {
          name: 'English',
          locale: 'en',
        },
        {
          name: 'Afrikaans',
          locale: 'af',
        },
        {
          name: 'Xhosa',
          locale: 'xh',
        },
      ],
    };
  },
  computed: {
    locales() {
      return this.supportedLocales.map((l) => ({
        name: this.getLocaleName(l),
        locale: l,
      }));
    },
  },
  methods: {
    /** Method used to get the locale name from the locale list
     */
    getLocaleName(locale) {
      return this.localeList.find((l) => l.locale === locale)?.name ?? locale;
    },
    /** Method used to switch the locale
     */
    switchLocale(locale) {
      this.$root.$i18n.locale = locale;
      this.locale = locale;
      /** Triggered when locale is changed.
      * @event input
      * @type {string}
      */
      this.$emit('input', locale);
    },
  },
};
</script>
<docs>
# LocaleSwitcher example

'''js
<LocaleSwitcher v-model="locale" />
'''
</docs>
